import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  column: {
    padding: '0 0 40px',
    width: '100%'
  },
  breadcrumbs: {
    marginTop: 16
  },

  button: {
    maxWidth: 536
  }
})
